import axios, { AxiosRequestConfig } from 'axios';

export interface ProfileFlag {
  flaggedId: number;
  flaggingId: number;
  description?: string;
  reason: { id: number };
}

export interface JobFlag {
  jobId: number;
  description?: string;
  reason: { id: number };
}

const PROFILE_URL = '/v2/profile-flag';
const JOB_URL = '/v2/job-flags';

class ContentFlagService {
  static flagProfile(
    data: ProfileFlag,
    config?: AxiosRequestConfig,
  ): Promise<unknown> {
    return axios.post(PROFILE_URL, data, config);
  }

  static flagJob(data: JobFlag, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.post(JOB_URL, data, config);
  }
}

export { ContentFlagService };
